module.exports = __webpack_public_path__ + "static/media/dailyBook-grey.a9b0a6f5.svg";